var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 4.5C12.1667 6.34095 13.6591 7.83333 15.5 7.83333M3 17L3.4533 14.7335C3.59456 14.0272 3.66519 13.6741 3.79435 13.3448C3.90899 13.0525 4.05765 12.7747 4.23726 12.5172C4.4396 12.2271 4.69426 11.9724 5.20356 11.4631L13.0001 3.66665C13.2346 3.43217 13.3518 3.31493 13.464 3.23049C14.1763 2.69442 15.1573 2.69443 15.8695 3.23051C15.9817 3.31496 16.0989 3.4322 16.3334 3.66669V3.66669C16.5679 3.90117 16.6851 4.01841 16.7696 4.1306C17.3056 4.84282 17.3056 5.82383 16.7695 6.53604C16.6851 6.64823 16.5679 6.76547 16.3334 6.99995L8.53687 14.7965C8.02758 15.3058 7.77293 15.5604 7.4828 15.7627C7.22528 15.9423 6.94751 16.091 6.65523 16.2057C6.32593 16.3348 5.9728 16.4054 5.26653 16.5467L3 17Z",
    stroke: "#99A4B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit-pen.c1ea6ce86cfcb37e24bfe19dfd89c809.svg";
export { ForwardRef as ReactComponent };